import { useAuth } from "@/context/AuthContext";
import { ClinicianDashboard } from "@/components/dashboards/ClinicianDashboard";
import { LabDashboard, PatientDashboard, ScopedDashboard } from "@/components/dashboards/OtherDashboards";
import { BrandDashboard } from "@/components/dashboards/BrandDashboard";

export default function DashboardPage() {
  const { user } = useAuth();
  if (["dx", "medtech"].includes(user.role)) return <BrandDashboard />;
  if (["admin", "doctor", "staff"].includes(user.role)) return <ClinicianDashboard />;
  if (user.role === "lab") return <LabDashboard />;
  if (user.role === "patient") return <PatientDashboard />;
  return <ScopedDashboard />;
}
